





















































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {MixinMember} from '@/components/mixins/MixinMember'
import {IResource, ObjectCollection, WholeCollection} from 'simpli-web-sdk'
import {Period} from '@/enums/Period'
import Motorista from '@/model/resource/Motorista'
import {ItrackCollection} from '@/helpers'
import DeliveryCanceledRequest from '@/model/request/DeliveryCanceledRequest'

@Component
export default class FilterDeliveryCanceled extends Mixins(MixinMember) {
  @Prop({required: true}) value!: DeliveryCanceledRequest

  allMotorista  = ItrackCollection.allMotorista

  get motoristaResource() {
      return this.allMotorista.get(this.value.idMotorista)
  }
  set motoristaResource(val: Motorista | null) {
      this.value.idMotorista = val && val.$id || null
  }

  Period = Period

  async mounted() {
    await this.allMotorista.query()
    await this.value.allCentroDeCusto.query()
    await this.value.allTipoInsumo.query()
  }

  get valueComputed() {
    return this.value
  }

  set valueComputed(val) {
    this.$emit('input', val)
  }

  allDocsEvent(item: IResource, cache: IResource[]) {
    this.value.populateAllDocs(cache)
  }

  cleanDocs() {
    this.value.cleanDocs()
  }

  searchByCTEEvent(item: IResource, cache: IResource[]) {
    this.value.populateSearchByCTE(cache)
  }

  formatSigla() {
    if (this.value.sigla) {
      this.value.sigla = this.value.sigla.toUpperCase()
    }
  }
}
